/* ============================================================
   Golden Vitality landing — interacciones + trigger Releasit COD.
   Cargado por layout/landing.liquid (case 'golden').
   ============================================================ */

/* Countdown (3h, resets on load) */
(function(){
  var end = Date.now() + 3*3600*1000;
  function pad(n){return (n<10?'0':'')+n;}
  function tick(){
    var d = Math.max(0, end - Date.now());
    var h = Math.floor(d/3600000), m = Math.floor(d%3600000/60000), s = Math.floor(d%60000/1000);
    var H=document.getElementById('xsc-h'), M=document.getElementById('xsc-m'), S=document.getElementById('xsc-s');
    if(H){H.textContent=pad(h);M.textContent=pad(m);S.textContent=pad(s);}
  }
  tick(); setInterval(tick,1000);
})();
/* Bundle selector + trigger Releasit viven juntos al final del archivo (ver IIFE goldenTriggerCOD)
   para compartir setVariantOnAllForms y la variante seleccionada. */
/* Rotating before/after image (every 2s) */
(function(){
  var ba=document.getElementById('xs-ba');
  if(!ba)return;
  var imgs=ba.querySelectorAll('img');
  if(imgs.length<2)return;
  var i=0;
  setInterval(function(){
    imgs[i].classList.remove('xs-ba--on');
    i=(i+1)%imgs.length;
    imgs[i].classList.add('xs-ba--on');
  },2000);
})();
/* Write-review modal */
(function(){
  var modal=document.getElementById('xs-review-modal');
  var openB=document.getElementById('xs-open-review');
  var closeB=document.getElementById('xs-modal-close');
  var form=document.getElementById('xs-review-form');
  var feed=document.getElementById('xs-feed');
  var starsBox=document.getElementById('xs-rv-stars');
  if(!modal||!openB)return;
  var rating=5;
  function open(){modal.classList.add('xs-modal--open');}
  function close(){modal.classList.remove('xs-modal--open');}
  openB.addEventListener('click',open);
  closeB.addEventListener('click',close);
  modal.addEventListener('click',function(e){if(e.target===modal)close();});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});
  // star picker
  starsBox.querySelectorAll('span').forEach(function(s){
    s.addEventListener('click',function(){
      rating=parseInt(s.getAttribute('data-v'));
      starsBox.querySelectorAll('span').forEach(function(x){
        x.classList.toggle('on', parseInt(x.getAttribute('data-v'))<=rating);
      });
    });
  });
  function esc(t){var d=document.createElement('div');d.textContent=t;return d.innerHTML;}
  form.addEventListener('submit',function(e){
    e.preventDefault();
    var name=document.getElementById('xs-rv-name').value.trim()||'Cliente';
    var text=document.getElementById('xs-rv-text').value.trim();
    if(!text)return;
    var stars='★★★★★'.slice(0,rating)+'☆☆☆☆☆'.slice(0,5-rating);
    var initial=esc(name.charAt(0).toUpperCase());
    var card=document.createElement('div');
    card.className='xs-rev xs-rev--new';
    card.innerHTML=
      '<div class="xs-rev__head">'+
        '<div class="xs-rev__avatar" style="background:var(--xs-accent);color:#0E0D0B;display:flex;align-items:center;justify-content:center;font-family:\'Archivo\',sans-serif;font-weight:900;">'+initial+'</div>'+
        '<div><div class="xs-rev__name">'+esc(name)+' <span class="xs-rev__verified">✓ Comprador Verificado</span></div>'+
        '<div class="xs-rev__date"><span class="xs-stars">'+stars+'</span> · hace un momento</div></div>'+
      '</div>'+
      '<p class="xs-rev__text">'+esc(text)+'</p>'+
      '<div class="xs-rev__react"><span>👍 0</span><span>0 comentarios</span><span>👍 Me gusta</span><span>💬 Comentar</span><span>⇧ Compartir</span></div>';
    feed.insertBefore(card, feed.firstChild);
    form.reset();
    rating=5;
    starsBox.querySelectorAll('span').forEach(function(x){x.classList.add('on');});
    close();
    card.scrollIntoView({behavior:'smooth',block:'center'});
  });
})();
/* Hub pill tabs */
document.querySelectorAll('.xs-hub__pill').forEach(function(p){
  p.addEventListener('click',function(){
    var t=p.getAttribute('data-hub');
    document.querySelectorAll('.xs-hub__pill').forEach(function(x){x.classList.remove('xs-hub__pill--active');});
    document.querySelectorAll('.xs-hub__panel').forEach(function(x){x.classList.remove('xs-hub__panel--active');});
    p.classList.add('xs-hub__pill--active');
    var panel=document.querySelector('.xs-hub__panel[data-hubpanel="'+t+'"]');
    if(panel)panel.classList.add('xs-hub__panel--active');
  });
});
/* Nutrition link -> ingredients */
var nl=document.getElementById('xs-nutri-link');
if(nl)nl.addEventListener('click',function(){var s=document.querySelector('.xs-ingredients');if(s)s.scrollIntoView({behavior:'smooth'});});
/* Info tabs */
document.querySelectorAll('.xs-tab__btn').forEach(function(btn){
  btn.addEventListener('click',function(){
    var t=btn.getAttribute('data-tab');
    document.querySelectorAll('.xs-tab__btn').forEach(function(x){x.classList.remove('xs-tab__btn--active');});
    document.querySelectorAll('.xs-tab__panel').forEach(function(p){p.classList.remove('xs-tab__panel--active');});
    btn.classList.add('xs-tab__btn--active');
    var panel=document.querySelector('.xs-tab__panel[data-panel="'+t+'"]');
    if(panel)panel.classList.add('xs-tab__panel--active');
  });
});

/* Hero gallery — clic en thumbnail cambia la imagen principal */
(function () {
  var main = document.querySelector('.xs-gallery__main img');
  var thumbs = document.querySelectorAll('.xs-gallery__thumb');
  if (!main || !thumbs.length) return;
  thumbs.forEach(function (thumb) {
    thumb.style.cursor = 'pointer';
    thumb.addEventListener('click', function () {
      var src = thumb.getAttribute('src');
      if (src) main.setAttribute('src', src);
      thumbs.forEach(function (t) { t.classList.remove('xs-gallery__thumb--active'); });
      thumb.classList.add('xs-gallery__thumb--active');
    });
  });
})();

/* ============================================================
   Releasit COD trigger — patrón canónico (memory/project_bundles_as_variants).
   NO usar _rsiV2.setState como primer path: no re-lee la variante tras cambiarla.
   El click nativo del botón Releasit SÍ re-lee window.productData.
   ============================================================ */
(function () {
  var RELEASIT_SELECTORS = [
    '#rsi_buy_now_button',
    '.rsi_buy_now_button',
    '._rsi-buy-now-button',
    '._rsi-buy-now-button-app-block-hook button',
    '._rsi-buy-now-button-app-block-hook a',
    '.rsi-btn-skel'
  ];

  function findReleasitButton() {
    for (var i = 0; i < RELEASIT_SELECTORS.length; i++) {
      var el = document.querySelector(RELEASIT_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  // Variante seleccionada — fuente de verdad en JS (no re-consultamos el DOM al disparar).
  var selectedVariantId = null;

  function setVariantOnAllForms(variantId) {
    if (!variantId) return;
    document.querySelectorAll('form[action="/cart/add"] input[name="id"]').forEach(function (input) {
      input.value = variantId;
    });
    document.querySelectorAll('input[name="product-id"]').forEach(function (input) {
      input.value = variantId;
    });
    if (window.productData && Array.isArray(window.productData.variants)) {
      var v = window.productData.variants.find(function (x) { return String(x.id) === String(variantId); });
      if (v) {
        window.productData.selected_or_first_available_variant = v;
        window.productData.selected_variant = v;
        try {
          document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
          document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v } }));
        } catch (e) {}
      }
    }
  }

  // Selección de bundle: en CADA click guardamos el id y sincronizamos la variante
  // de inmediato (no esperamos al botón comprar). Esto evita el bug "siempre muestra
  // el precio del bundle activo por defecto" cuando Releasit lee la variante al abrir.
  function selectBundle(label) {
    var id = label.getAttribute('data-bundle-variant-id');
    if (!id) return;
    document.querySelectorAll('.xs-bundle').forEach(function (x) { x.classList.remove('xs-bundle--active'); });
    label.classList.add('xs-bundle--active');
    selectedVariantId = id;
    setVariantOnAllForms(id);
  }

  var bundles = document.querySelectorAll('.xs-bundle[data-bundle-variant-id]');
  bundles.forEach(function (label) {
    label.addEventListener('click', function () { selectBundle(label); });
  });

  // Init: tomar el bundle marcado activo (o el primero) como variante inicial.
  (function initSelected() {
    var active = document.querySelector('.xs-bundle--active[data-bundle-variant-id]') || bundles[0];
    if (active) {
      selectedVariantId = active.getAttribute('data-bundle-variant-id');
      setVariantOnAllForms(selectedVariantId);
    }
  })();

  window.goldenTriggerCOD = function (btn) {
    // Prioridad: id propio del botón (si lo tuviera) > variante seleccionada en el selector.
    var variantId = (btn && btn.getAttribute && btn.getAttribute('data-bundle-variant-id')) || selectedVariantId;
    if (variantId) setVariantOnAllForms(variantId);
    setTimeout(function () {
      var releasitBtn = findReleasitButton();
      if (releasitBtn) { releasitBtn.click(); return; }
      var attempts = 0;
      var poll = setInterval(function () {
        attempts++;
        var b = findReleasitButton();
        if (b) { clearInterval(poll); b.click(); return; }
        if (attempts > 30) {
          clearInterval(poll);
          if (window._rsiV2 && typeof window._rsiV2.setState === 'function') {
            try { window._rsiV2.setState({ isOpen: true }); } catch (e) {}
          }
        }
      }, 100);
    }, 50);
  };
})();
